export default __webpack_public_path__ + "static/media/tool-field-outdoor-quarter.f2f8fce6.svg";